import { render, staticRenderFns } from "./EmptyStateArt.vue?vue&type=template&id=67fd7da0&"
import script from "./EmptyStateArt.vue?vue&type=script&lang=js&"
export * from "./EmptyStateArt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports